export const LIGHT = {
  primary: '#173659',
  navbar: '#051229',
  cta: '#FBAF1A',
  text: '#3E4C59',
  paper: '#FFFFFF',
};

export const DARK = {
  primary: '#173659',
  navbar: '#051229',
  cta: '#FBAF1A',
  text: '#fff',
  paper: '#2f3742',
};
